import React from 'react';
import { EmptyGreyBlob } from '../Icons';

interface Props {
  icon?: React.ReactNode;
}

export function BlobWithIcon({ icon }: Props) {
  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        padding: '32px 32px 0px 32px',
      }}
    >
      <EmptyGreyBlob width="97" height="97" />
      {icon && <div style={{ position: 'absolute' }}>{icon}</div>}
    </div>
  );
}
